import React from 'react';
import PropTypes from 'prop-types';
import {StyleSheet} from 'react-native';

import DropdownPicker from 'components/DropdownPicker';

const DeviceSelectionPicker = ({
  selectedValue,
  onValueChange,
  pickerItemObjects,
}) => {
  const items = pickerItemObjects.map((value) => ({
    label: value?.label,
    value: value?.deviceId,
  }));

  return (
    <DropdownPicker
      selectedValue={selectedValue}
      onValueChange={(value) => {
        onValueChange(value);
      }}
      items={items}
      style={styles.picker}
    />
  );
};

DeviceSelectionPicker.propTypes = {
  selectedValue: PropTypes.string.isRequired,
  onValueChange: PropTypes.func.isRequired,
  pickerItemObjects: PropTypes.array.isRequired,
};

const styles = StyleSheet.create({
  picker: {
    marginTop: 8,
    width: 250,
  },
});

export default DeviceSelectionPicker;
